const METER_STORAGE_DECIMAL_PLACES = 10;

export function parseStopValue(value: string): number {
  if (value === '-' || value.trim() === '') return 0;
  const parsed = parseFloat(value);
  return isNaN(parsed) ? 0 : parsed;
}

/** Whether `stops` are value-descending (equal values allowed). */
export function isSortedByValueDescending(
  stops: readonly { value: string }[]
): boolean {
  for (let index = 1; index < stops.length; index++) {
    if (
      parseStopValue(stops[index - 1].value) <
      parseStopValue(stops[index].value)
    ) {
      return false;
    }
  }
  return true;
}

/** Persist metres with enough precision to round-trip the active display unit. */
export function formatMeterValueForStorage(valueInMeters: number): string {
  if (Number.isInteger(valueInMeters)) {
    return String(valueInMeters);
  }
  return (
    valueInMeters
      .toFixed(METER_STORAGE_DECIMAL_PLACES)
      // eslint-disable-next-line sonarjs/super-linear-regex -- input is a short toFixed() result
      .replace(/\.?0+$/, '')
  );
}
